"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$EmailOptionsResponseDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$EmailOptionsResponseDto = {
    properties: {
        email: {
            type: 'string',
            description: `The title of the notification, which is the text that will be displayed in the notification.`,
            isRequired: true,
        },
        lang: {
            type: 'string',
            description: `Lang to send the email accept: es, en.`,
            isRequired: true,
        },
    },
};
